<template>
  <!--8.3项目详情钻取页面-->
  <div class="container">
    <div class="header">
      <i
        class="icon-fanhui iconfont icon back"
        @click="back"
        style="position: absolute;left:0.1rem"
      ></i>
      <div>项目详情</div>
    </div>
    <!--v-model="selected"-->

    <mt-navbar v-model="selected">
      <mt-tab-item id="1">概况</mt-tab-item>
      <mt-tab-item id="2">项目动态</mt-tab-item>
      <mt-tab-item id="3">回款进程</mt-tab-item>
    </mt-navbar>

    <!-- tab-container  v-model="selected"-->
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="1">
        <!--概况-->
        <div class='Survey'>
          <ul class='Survey-top'>
            <li>
              <span class="c-333">甲方名称</span>
              <span class="c-666">{{currentPro.first_party}}</span>
            </li>
            <li>
              <span class="c-333">项目名称</span>
              <span class="c-666">{{currentPro.name}}</span>
            </li>
            <li>
              <span class="c-333">报价金额（元）</span>
              <span class="c-666">{{currentPro.money}}</span>
            </li>
            <li>
              <span class="c-333">已回款金额（元）</span>
              <span class="c-666">{{currentPro.back_money}}</span>
            </li>
            <li>
              <span class="c-333">项目状态</span>
              <span class="c-666">{{phase[currentPro.phase]}}</span>
            </li>
            <li>
              <span class="c-333">完成度</span>
              <span class="c-666">{{currentPro.complete}}%</span>
            </li>
            <li>
              <span class="c-333">启动时间</span>
              <span class="c-666">{{currentPro.start_date}}</span>
            </li>
            <li>
              <span class="c-333">完成时间</span>
              <span class="c-666">{{currentPro.completed_date?currentPro.completed_date:'暂无'}}</span>
            </li>
          </ul>

          <div class="Survey-center">
            <ul class="step-container">
              <li
                v-for="item in phaseLists"
                :key="item.id"
                :class="getCurrentStep(item.id,currentPro.phase)"
              >{{(item.id-0+1)}}
                <span :class="getCurrentArrow(item.id,currentPro.phase)">
                  <span class="arrow-pre"></span>
                  <span class="arrow-next"></span>
                </span>
              </li>
              <li :class="getLastStep(currentPro.phase)">7</li>
            </ul>
            <ul class="step-title">
              <li
                v-for="(item,index) in phase"
                :key="index"
                :style="isActive(index,currentPro.phase)"
              >{{item}}</li>
            </ul>
          </div>
          <div
            class="Survey-bottom"
            v-if="Array.isArray(groupList)"
          >
            <mt-progress
              :value="Number(item.value)"
              v-for="(item,index) in groupList"
              :barHeight="parseInt(10)"
              :key="index"
            >
              <div
                slot="start"
                style="position: absolute;top:-0.4rem;left:0.1rem;"
              >{{item.name}}</div>
              <div slot="end">{{item.value?parseInt(item.value):0}}%</div>
            </mt-progress>
          </div>
          <div
            v-else
            style="text-align:center;font-size:16px;margin-top:10px;"
          >暂无任务数据</div>
        </div>

        <!--<mt-cell v-for="n in 10" :title="'content ' + n" />-->
      </mt-tab-container-item>
      <!--项目动态-->
      <mt-tab-container-item id="2">
        <div class="tasklogs">
          <ul
            v-for="(item,index) in tasklogs"
            :key="index"
          >
            <div class="datecircle">
              <span class="currentdate">{{getDay(item.time)}}</span>
            </div>
            <li
              v-for="(item1,index1) in item.task"
              :key="index1"
            >
              <span class="g_circle"></span>
              <span class="userimg">
                <img
                  :src='getSrc(item1.avatar_path)'
                  class="img02"
                  style="border-radius: 50%;"
                  v-if="item1.avatar_path"
                />
                <span
                  style="display: inline-block;margin-right: 8px;"
                  v-if="item1.avatar_path"
                ></span>
                <img
                  src="../../assets/img/user-avatar.png"
                  alt=""
                  class="img02"
                  v-if="!item1.avatar_path"
                >
                <span
                  class="avatar-name"
                  v-if="!item1.avatar_path"
                >{{(item1.name).slice(0,1)}}</span>

              </span>

              <span class="username">
                <span class="name">{{item1.name}}</span>
                <span class="remark">{{item1.remark}}</span>
                <span class="title">{{item1.title}}</span>
                <span class="currenttime">{{item1.time}}</span>
              </span>
            </li>
          </ul>
          <nodata v-if="!tasklogs.length"></nodata>

          <!-- <div v-if="!tasklogs.length"
               style="text-align: center;margin-top:10px;">暂无数据</div> -->
        </div>

      </mt-tab-container-item>
      <mt-tab-container-item id="3">
        <!--回款进程-->
        <div
          class="list-wrapper"
          style="margin-top:30px;"
        >
          <div
            class="list-item"
            v-for="(item,index) in payment"
            :key="index"
          >
            <div class="top">
              <span
                class="left"
                style="display: inline-block;font-size: 14px;"
              >第{{item.period}}期</span>

            </div>
            <ul class="center">
              <li>
                <span>暂无</span>
                <span>预期回款时间</span>
              </li>
              <li>
                <span>{{item.billed_at?(item.billed_at.slice(0,10)):'暂无'}}</span>
                <span>开票时间</span>
              </li>
              <li>
                <span>{{item.updated_at?(item.updated_at.slice(0,10)):'暂无'}}</span>
                <span>实际回款时间</span>
              </li>
            </ul>
            <ul class="bottom">
              <li>
                <span class="money">{{item.sc_money?(item.sc_money/10000).toFixed(2):0}} <span class="unit">(万)</span></span>
                <span>预计回款金额</span>
              </li>
              <li>
                <span class="money">{{item.nt_money?(item.nt_money/10000).toFixed(2):0}} <span class="unit">(万)</span></span>
                <span>开票金额</span>
              </li>
              <li>
                <span class="money">{{item.money?(item.money/10000).toFixed(2):0}} <span class="unit">(万)</span></span>
                <span>实际回款金额</span>
              </li>
            </ul>

          </div>
        </div>
        <!--<mt-cell v-for="n in 6" :title="'content ' + n" />-->
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>
<script>
  import { Navbar, TabItem, Progress } from 'mint-ui'
  import nodata from '../public/nodata'
  import Vue from 'vue'

  Vue.component(Navbar.name, Navbar);
  Vue.component(TabItem.name, TabItem);
  Vue.component(Progress.name, Progress);

  export default {
    components: {
      nodata
    },
    data() {
      return {
        selected: '1',
        project_id: '',//项目id
        groupList: [],
        phase: [],
        currentPro: {},//当前项目
        payment: [],
        tasklogs: [],
        phaseLists: [{ id: '0', name: '1' }, { id: '1', name: '2' }, { id: '2', name: '3' }, { id: '3', name: '4' }, { id: '4', name: '5' }, { id: '5', name: '6' }],
      }
    },
    methods: {
      getCurrentStep(index, phase) {
        if (phase > index) {
          return 'step-past'
        }
        if (phase == index) {
          return 'step-current'
        } else {
          return 'step-no-past'
        }
      },
      getCurrentArrow(index, phase) {
        if (phase > index) {
          return 'arrow arrow-past'
        }
        if (phase == index) {
          return 'arrow arrow-current'
        }
        else {
          return 'arrow arrow-no-past'
        }
      },
      getLastStep(phase) {
        if (phase > 6) {
          return 'step-past'
        }
        if (phase == 6) {
          return 'step-current'
        }
        if (phase < 6) {
          return 'step-no-past'
        }
      },
      isActive(index, phase) {
        if (phase > index) {
          return 'color:#00AA00'
        }
        if (phase == index) {
          return 'color:#EE7700'
        } else {
          return 'color:#AAAAAA'
        }
      },
      back() {
        this.$router.go(-1)
        // this.$router.push({ name:'businessmon' })
      },
      getDay(time) {//日期转换
        if (time) {
          let month = time.slice(5, 7)
          let day = time.slice(8, 10)
          return `${month}/${day}`
        }
      },
      getSrc(path) {//获取头像
        return `${path}`
      },
    },
    created() {

      this.project_id = this.$route.params.project_id
      this.$http.getProDetail({ project_id: this.$route.params.project_id }).then(res => {// 概况页面信息
        this.groupList = res.data.new_data//各小组进度条数组
        this.phase = res.data.phase//进度数组
        this.currentPro = res.data.project;
        this.payment = res.data.payment
      })
      this.$http.getPrologs({ project_id: this.$route.params.project_id }).then(res => {//日志详情页面
        this.tasklogs = res.data.data
      })

    },
  }
</script>
<style scoped>
  .container {
    width: 100%;
    background-color: #fff;
  }
  .header {
    width: 100%;
    text-align: center;
    font-size: 0.375rem;
    background-color: #fff;
    height: 1.04375rem;
    line-height: 1.09375rem;
    position: relative;
    z-index: 99;
    border-bottom: 1px solid #ccc;
  }
  .container /deep/ .mint-navbar {
    border-bottom: 1px solid #ccc;
    color: #737171;
  }
  .container /deep/ .mint-tab-item-label {
    font-size: 15px;
  }
  .container /deep/ .mint-navbar .mint-tab-item.is-selected {
    color: #5483d2;
    font-weight: 600;
    text-decoration: none;
  }
  .container /deep/ .mint-navbar .mint-tab-item.is-selected {
    border-bottom: 2px solid #5483d2;
  }

  .Survey-top > li {
    padding: 0 0.5rem;
    height: 1.1rem;
    line-height: 1.1rem;
    border-bottom: 1px solid #cccccc;
    display: flex;
    justify-content: space-between;
  }
  .Survey-center {
    margin: 0.8rem 0rem 0.8rem 0.2rem;
    overflow: hidden;
  }
  .step-container {
    margin: 0;
    padding-left: 10px;
    width: 100%;
  }
  .step-container li {
    display: inline-block;
    position: relative;
    margin: 0;
    padding: 0;
    width: 13.6%;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    white-space: space break-all;
    text-align: center;
    background-color: #ccc;
    color: #ffffff;
  }
  .step-container li.step-past {
    background-color: #00aa00;
    width: 13.2%;
  }
  .step-container li.step-current {
    /* 中间背景色 */
    background-color: #ee7700;
  }
  .step-container li.step-no-past {
    /* 中间背景色 */
    background-color: #ccc;
  }
  .arrow {
    position: absolute;
    right: -7.5px;
    height: 30px;
    background-color: #ffffff;
    z-index: 2;
  }
  .arrow span {
    display: inline-block;
    border-left: 15px solid transparent;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
  }
  .arrow-next {
    margin-left: -15px;
  }
  .arrow-past .arrow-pre {
    /* 角标 尖尖*/
    border-left: 15px solid #00aa00;
  }
  .arrow-past .arrow-next {
    /* 通过的左右角标 */
    border-top: 15px solid #00aa00;
    border-bottom: 15px solid #00aa00;
  }
  .arrow-current .arrow-pre {
    /* 角标 尖尖*/
    border-left: 15px solid #ee7700;
  }
  .arrow-current .arrow-next {
    border-top: 15px solid #ee7700;
    border-bottom: 15px solid #ee7700;
  }
  .arrow-no-past .arrow-pre {
    border-left: 15px solid #ccc;
  }
  .arrow-no-past .arrow-next {
    border-top: 15px solid #ccc;
    border-bottom: 15px solid #ccc;
  }
  .step-title {
    padding-left: 10px;
  }
  .step-title > li {
    width: 13.4%;
    float: left;
  }
  .step-title > li:last-child {
    text-align: center;
  }
  .textval {
    position: relative;
    top: 0.1rem;
    left: 0.28rem;
    font-weight: 600;
    font-size: 15px;
  }
  .Survey-bottom {
    margin-top: 0.6rem;
    position: relative;
    left: 0.5rem;
    right: 0.5rem;
    width: 90%;
    padding: 0 0.1rem;
  }
  .Survey-bottom /deep/ .mt-progress-progress {
    /*进度条样式的调整*/
    background-color: #52c6bf;
    border-radius: 4px;
  }
  .Survey-bottom /deep/ .mt-progress-runway {
    /* width: 7.7rem; */
    border-radius: 4px;
  }
  .c-52C6BF {
    color: #52c6bf;
  }
  .c-C4C8C8 {
    color: #c4c8c8;
  }
  .c-333 {
    color: #333;
  }
  .c-666 {
    color: #666;
  }
  .child-two > span {
    display: inline-block;
    width: 1rem;
    margin-right: 0.27rem;
  }
  /*日志页面项目动态*/
  .tasklogs {
    padding: 0.3rem;
  }
  .datecircle {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    border: 3px solid #d2e8eb;
  }
  .tasklogs > ul li {
    margin-left: 0.7rem;
    border-left: 1px solid #ccc;
    padding: 0.5rem 0rem;
  }
  .currentdate {
    font-size: 15px;
    font-weight: 600;
    position: relative;
    top: 0.3rem;
    left: 0.1rem;
    color: #4986f9;
  }
  .g_circle {
    display: inline-block;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: #52c6bf;
    position: relative;
    left: -0.2rem;
  }
  .img02 {
    width: 35px;
    height: 35px;
    position: relative;
    top: 10px;
  }
  .avatar-name {
    position: relative;
    top: -2px;
    left: -30px;
    font-size: 15px;
  }
  .username {
    position: relative;
    left: -12px;
  }
  .username .remark {
    margin-left: 0.3rem;
  }
  .title {
    color: #4986f9;
    display: block;
    margin: 0.2rem 0 0 2.3rem;
  }
  .currenttime {
    position: relative;
    top: 0px;
    float: right;
    color: #999;
  }
  .top {
    overflow: hidden;
  }
  .center {
    margin-top: 0.2rem;
  }
  .center,
  .bottom {
    display: flex;
    justify-content: space-between;
  }
  .center > li > span,
  .bottom > li > span {
    display: block;
  }
  .bottom {
    margin-top: 0.5rem;
    padding-bottom: 0.1rem;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
  .list-item {
    color: #999;
  }
  .money {
    font-size: 20px;
    color: #5482d2;
  }
  .unit {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/drillPage/ProjectDetailDrill.vue